import React from "react";
import Skeleton from "react-loading-skeleton";

const ConverstaionLoader = () => {

    return (
        <>
            <ul className="messages_list w-list-unstyled">

                {Array(8)
                    .fill(0)
                    .map((item, index) => (
                        <li className="messages_item" key={index} style={{ zIndex: 0 }}>
                            <div className="messages_link w-inline-block" style={{ opacity: 0.8 }}>
                                <div style={{ padding: 5 }}>

                                    <div className="messages_pict">
                                        <Skeleton circle={true} height={60} width={60} />
                                    </div>
                                </div>

                                <div className="messages_infogroup" style={{ width: '100%' }}>
                                    <h4 className="messages_info_title"><Skeleton width={`60%`} /></h4>
                                    <div><Skeleton width={`80%`} /></div>
                                </div>
                            </div>
                        </li>
                    ))}
            </ul>
        </>
    )

}

export default ConverstaionLoader;